import 'moment/locale/pt-br';
import Vue from 'vue';
import Vuelidate from 'vuelidate';
import VueGtag from 'vue-gtag';
import VueToast from 'vue-toast-notification';
import VueAxios from 'vue-axios';
import vueMoment from 'vue-moment';
import moment from 'moment';
import Fragment from 'vue-fragment';
import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm';
import BootstrapVueIcons from 'bootstrap-vue/dist/bootstrap-vue-icons.esm';
import MenuIcon from 'vue-material-design-icons/Menu';
import VueTheMask, { tokens as vueTheMaskTokens } from 'vue-the-mask';
import money from 'v-money';
import axios from './configurations/service';
import validate from './configurations/validations';
import App from './App';
import router from './router';
import store from './store';

import 'vue-material-design-icons/styles.css';
import 'vue-toast-notification/dist/theme-default.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './assets/themes/variables.css';
import './assets/styles/App.scss';

moment.locale('pt-br');
Vue.component('menu-icon', MenuIcon);
Vue.use(Fragment.Plugin);
Vue.use(vueMoment, {
  moment,
});
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueAxios, axios());
Vue.use(VueToast, {
  position: 'top-right',
  duration: 4000,
  onClose: () => {
    Vue.prototype.$alert.isOpen = false;
  },
});
Object.assign(vueTheMaskTokens, {
  U: {
    pattern: /[a-zA-Z0-9]/,
    transform: (v) => v.toLocaleUpperCase(),
  },
});
Vue.use(VueTheMask);
Vue.use(money);
Vue.use(Vuelidate);
Vue.config.productionTip = false;

function showToast(type, message, options) {
  Vue.prototype.$toast[type](message, options);
  Vue.prototype.$alert.isOpen = true;
}

Vue.prototype.$alert = {
  ...Vue.prototype.$toast,
  isOpen: false,
  error: (message, optional) => showToast('error', message || 'Ocorreu um erro inesperado', optional),
  warning: (message, optional) => showToast('warning', message, optional),
  success: (message, optional) => showToast('success', message, optional),
  info: (message, optional) => showToast('info', message, optional),
  default: (message, optional) => showToast('default', message, optional),
  open: (message, optional) => showToast('open', message, optional),
};

Vue.prototype.$validate = validate;

Vue.use(
  VueGtag,
  {
    config: { id: 'UA-64061311-1' },
  },
  router,
);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
